'use client';

import { PLANS, type Plan } from '@/entities/plan';


type UsePlansResult = {
    plans: Plan[];
    isLoading: boolean;
    error: string | null;
};


export const usePlans = (): UsePlansResult => {
    return {
        plans    : PLANS,
        isLoading: false,
        error    : null,
    };
};
